<template>
    <div class="home">
        <Header @cart-ref="setCartRef" />
        <AdminHomeContent :cart-component="cartComponent" />
    </div>
</template>

<style scoped src="../styles/Home.css" />

<script>
import Header from '../components/Header.vue';
import AdminHomeContent from '../components/AdminHomeContent.vue';

export default {
    name: 'HomeView',
    components: {
        Header,
        AdminHomeContent
    },

    data() {
        return {
            cartComponent: null
        };
    },

    methods: {
        setCartRef(cartRef) {
            this.cartComponent = cartRef;
        }
    },

    mounted() {
        window.scrollTo(0, 0);
    }
};
</script>